












































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { validateFioData } from '@/mixins/validateFioData';
import { required, and, email } from 'vuelidate/lib/validators';
import { validateFio } from '@/tools/validatefio';
import { validateSnils } from '@/tools/validateSnils';
import { Form, FormInput, Select } from '../../../../form';
import { Button } from '../../../../../components';
import { IAddChild } from './types';
import {
  PHONE_MASK,
  SNILS_MASK,
  SEND_INVITE,
  INVITE_PERSON,
  SNILS_ERROR_EMPTY,
  SNILS_ERROR_FORMAT,
  EMAIL_FORMAT_ERROR,
  EMAIL_REQUIRED_ERROR,
} from './consts';
import { OptionsType } from '@/pages/profile/views/general/types';

const getData = () => ({
  email: '',
  first_name: '',
  last_name: '',
  phone: '',
  municipality_id: '',
  snils: '',
});

Component.registerHooks(['validations']);

@Component({
  components: {
    Form,
    FormInput,
    Button,
    Select,
  },

  mixins: [validateFioData, validationMixin],
})
export default class AddChild extends Vue implements IAddChild {
  @Prop({ type: Object, default: null })
  readonly apiErrors!: any;

  phoneMask: Array<any> = PHONE_MASK;
  snilsMask: Array<any> = SNILS_MASK;
  invitePerson: any = {};
  errors: any = {};

  get v() {
    return (this as AddChild).$v!.invitePerson;
  }

  get municipalitiesOptions() {
    const { municipalities } = this.$store.state;
    return municipalities
      ? municipalities.map(({ name, id }: OptionsType) => ({
          text: name,
          value: id,
        }))
      : [];
  }

  get submitBtnText(): string {
    return this.validateForm ? SEND_INVITE : INVITE_PERSON;
  }

  get snilsErrorText() {
    return !this.invitePerson.snils ? SNILS_ERROR_EMPTY : SNILS_ERROR_FORMAT;
  }

  get emailErrorText() {
    const { v } = this;
    return v.email.required ? EMAIL_FORMAT_ERROR : EMAIL_REQUIRED_ERROR;
  }

  get validateForm(): boolean {
    return !this.v.$invalid;
  }

  @Watch('apiErrors')
  setErrors(value: any) {
    if (value) {
      this.errors = value;
    }
  }
  validations() {
    const invitePerson: any = {
      municipality_id: {
        required,
      },

      first_name: {
        required,
        validateFio,
      },

      last_name: {
        required,
        validateFio,
      },

      email: {
        required,
        email,
      },

      phone: {
        required,
        and: and((value: string) =>
          /^\+7 \([1-9]\d\d\) \d\d\d-\d\d-\d\d$/.test(value),
        ),
      },

      snils: {
        required,
        validateSnils,
      },
    };

    return { invitePerson };
  }

  mounted(): void {
    this.reset();
  }

  submit() {
    const { validateForm, invitePerson } = this;
    if (validateForm) {
      this.$emit('submit', {
        ...invitePerson,
        snils: invitePerson!.snils.replace(/\s|-/g, ''),
      });
    }
  }

  onInput(value: string) {
    if (value.includes('.')) {
      delete this.errors[value.split('.')[1]];
      (this as any).formatFio(value);
    } else {
      delete this.errors[value];
    }
  }

  reset() {
    this.invitePerson = getData();
    (this as AddChild).$v!.$reset();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/addchildform/AddChild.vue